import { render } from "./AlarmSettingsEdit.vue?vue&type=template&id=1a42e382"
import script from "./AlarmSettingsEdit.vue?vue&type=script&lang=js"
export * from "./AlarmSettingsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__